import { Vue, Component, Prop } from "vue-property-decorator";

// Helpers
import { getEmptyProductImageUrl } from "@/plugins/products_helper";
import { localCurrency } from "@/plugins/currency";

@Component({ methods: { localCurrency } })
export default class MealCard extends Vue {
  @Prop({ default: null }) meal;
  @Prop({ default: null }) menuId;
  @Prop({ default: true }) isEditButtonEnabled: boolean;
  @Prop({ default: "Seleccionar" }) mainButtonLabel;
  @Prop({ default: "Detalles del plato" }) secondaryButtonLabel;

  get mealInfo() {
    let response = "";
    this.getMealItems.forEach((item, index) => {
      if (index === this.getMealItems.length - 1) response += `${item.name}.`;
      else response += `${item.name}, `;
    });
    return response;
  }

  get getMealItems() {
    const { items, product_menu_items } = this.meal;
    if (items) return items;
    else if (product_menu_items) return product_menu_items;
    return [];
  }

  get mealOverCost() {
    let response = 0;
    this.getMealItems.forEach((item) => (response += item.over_price));
    return response;
  }

  changeMeal() {
    this.$router.push({
      name: "chefSuggestions",
      query: { menu_id: this.menuId, count_id: this.meal.count_id },
    });
  }

  seeDishDetails() {
    this.$emit("see-dish-details", this.meal);
  }

  getProductMenuItemImage(productMenuItem) {
    const { img } = productMenuItem;
    if (!img || !img.url) return getEmptyProductImageUrl();
    return img.url;
  }
}
